
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'textFieldStyle': {'width': `100%`,'paddingTop': `2px`,'margin': `auto`,'marginTop': `24px`,'variant': `outlined`,},'inputStyle': {'fontSize': `17px`,'textAlign': `left`,'border': `1px solid transparent`,'paddingLeft': `12px`,'paddingRight': `12px`,'paddingTop': `12px`,'color': `#000000`,'backgroundColor': `transparent`,'borderRadius': `5px`,'fontFamily': `'Lato-Regular-Regular', sans-serif`,},'inputMultilineStyle': {'fontSize': `17px`,'textAlign': `left`,'border': `1px solid #dddddd`,'borderRadius': `2px`,'padding': `10px 12px`,'color': `#000000`,'height': `180px`,},'textFieldHelperText': {'color': `#000000`,'fontSize': `1rem`,'marginLeft': `14px`,},'textFieldInputBoxProps': {'disableUnderline': `true`,},
        
      };
    };
  